import React from 'react';
import { get } from 'lodash';
import { AUDIENCE_STATUS } from 'modules/audiences/config';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { FormattedNumberCellRenderer } from './index';

const ONE_BILLION_AUDIENCE_SIZE = 1_000_000_000;

export const AudienceSizeCellRenderer = data => {
    const audienceSize = get(data, 'value');
    const status = get(data, 'data.status');
    const shouldShowZeroSpend = status !== AUDIENCE_STATUS.READY && status !== AUDIENCE_STATUS.ACTIVE;
    const displayedAudienceSize = shouldShowZeroSpend ? 0 : audienceSize;

    if (displayedAudienceSize > ONE_BILLION_AUDIENCE_SIZE) {
        return (
            <div>
                <FormattedMessage
                    id="audience.editor.predictive.audience.report.monthlyReach"
                    defaultMessage="Over 1B"
                />
            </div>
        );
    }

    return <FormattedNumberCellRenderer value={displayedAudienceSize} />;
};
